module.exports = __webpack_public_path__ + "static/media/xxYellow.0f066e1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/xxYellow.png
// module id = 1877
// module chunks = 0 1